define('responsive-gameday-scoreboard/src/js/GamedayScoreboard',['require','exports','module','jquery','es6ish-class/es6ish-class','requirejs-hogan-plugin/hogan','GameModel/GameModel','./GameDayScoreboardGameExtender','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','text!../templates/gd_scoreboard.tpl','gameday-index-url-hasher/UrlHasher','iscroll/build/iscroll','moment','gid-decoder/GidDecoder'],function (require, module, exports) {

    var $ = require('jquery'),
        es6ishClass = require('es6ish-class/es6ish-class'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        GameModel = require('GameModel/GameModel'),
        GameDayScoreboardGameExtender = require('./GameDayScoreboardGameExtender'),
        dispatcher = require("message-service/message-service"),
        LoadEvts = require('gameday-index-enums/enums/events/LoadEvents'),
        scoreboardTemplate = hogan.compile(require('text!../templates/gd_scoreboard.tpl')),	
        UrlHash = require('gameday-index-url-hasher/UrlHasher'),
        iScroll = require('iscroll/build/iscroll'),
        Moment = require('moment'),
		GID = require("gid-decoder/GidDecoder"),
		sbScroll,
		 usableOptions = {
            bindToWrapper       : true,
            mouseWheel          : false,
            interactiveScrollbars : true,
            scrollX: true, 
            scrollY: false,
            scrollbars: true,
            preventDefault : true,
            fadeScrollbars : true,
            snap : true,
            eventPassthrough : 'vertical'
        };
        
		iScroll=window.IScroll||window.iScroll;
 
    function formatDate(date) {
        var year = date.substr(0, 4);
        var month = date.substr(4, 2);
        var day = date.substr(6);
        return year + "/" + month + "/" + day;
    }
 
    var GamedayScoreboard = es6ishClass(function(selectorString) {

        // Set where on the page this is going on Scoreboard instance creation
        this.targetDivSelector = selectorString;

        $(this.targetDivSelector).on('click', '.game:not(.nixed)', function () {
            var $clickedGame = $(this);
            var gameObj = {
                    id: $clickedGame.attr('id'),
                    game_pk: $clickedGame.data('game-pk'),
                    season: $clickedGame.data('season'),
                    away_team_id: $clickedGame.find('.teamInfo .away').data('team-id'),
                    home_team_id: $clickedGame.find('.teamInfo .home').data('team-id'),
                    game_date: $clickedGame.data('game-date'),
                    game_type: $clickedGame.data('game-type')
                },
                lookin = $clickedGame.attr('data-id');

            // Handle live lookin (this isn't doing anything at the moment)
            if (typeof lookin !== "undefined") { gameObj.liveLookin = lookin; }

            // Handle switching to clicked game
            UrlHash.removeHashParam('lock_state');
            UrlHash.setHashParams({
                game : gameObj.id
            });
            dispatcher.publish("GDScoreboardTracking",{
                dynamic_component: "Gameday Scoreboard",
                dynamic_componentAction: "Gameday: Scoreboard Game Select",
                isDynamic: true
            });
            // Game changed, publish said event
            dispatcher.publish(LoadEvts.gameChanged, gameObj);

            $('.games .game').removeClass('highlightedGame');
            $('#' + gameObj.id).addClass('highlightedGame');
        });

        // Date was changed, destroy current instance, which stops master scoreboard poller and re-init with new date
        dispatcher.addListener.call(this, LoadEvts.dateChanged, function(date) {
            this.changeDate(date);
        });
    });

    GamedayScoreboard.define({
        /**
         * Where are we placing this component?
         */
        targetDivSelector: "",
        /**
         * Instance of GameModel this scoreboard is displaying
         */
        gameModel: null,
        /**
         * load method creates a GameModel with proper date, updates template and markup with new data.
         * New GameModel starts Game Poller for auto updating
         */
       
        
        init: function (config) {
            var sbInstance = this;
            var gameIDInHashExists = UrlHash.getHashParams().game;
            // Enable support outside game day (and without game param hash present)
            var gid = gameIDInHashExists ? GID.decodeGID(UrlHash.getHashParams().game) : {
                gameDateString: Moment().format('MM/DD/YYYY')
            };     
            var opt = $.extend({}, {
                date: new Date(gid.gameDateString),
                sport_code: gid.home_sport_code,
                targetDivSelector: this.targetDivSelector
            }, config);

            GameModel.createModel({
                date: opt.date,
                sport_code: opt.sport_code,
                extender: new GameDayScoreboardGameExtender(opt.date)
            }).done(function(model) {
                sbInstance.gameModel = model;
                //Initial Payload
                model.on('loadSuccess', function(games) {
   
                    $(opt.targetDivSelector).html(scoreboardTemplate.render(games));
                    // not sure why iscroll needs the defined width??
                    $(".sbMini .gamesContainer").css("width", $("ul#games").width());
                    sbScroll = new iScroll('#sbMini', usableOptions);
                });
                //Updated payload after game poller
                model.on('refresh', function(games) {
                    $(opt.targetDivSelector).html(scoreboardTemplate.render(games));
                });
                model.init();
            });
        },
        /**
         * We're changing dates, destroy game model and recreate it with new dates. 
         * Kills any previous game pollers that were spun up for previous dates.
         */
        changeDate: function (date) {
            this.gameModel.destroy();
            this.gameModel.load(date);
            $('#GDPostseasonScoreboardContent').hide();
            $('#GDScoreboardContent').show();
        }
    });
 
    return GamedayScoreboard;
});
